module.exports = __webpack_public_path__ + "img/cloud-cross.7c9aedbf.svg";